import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import 'moment/locale/nl';
import 'moment/locale/de';
import 'moment/locale/en-gb';

const useMomentLocale = () => {
    const { currentLanguageCode, locales } = useSelector(state => state.appTranslations);

    useEffect(() => {
        // Build locale map dynamically from API locales
        const localeMap = {};
        locales?.forEach(locale => {
            // Map both full code (nl_NL) and short code (nl) to moment locale (nl)
            if (locale.short) {
                localeMap[locale.code] = locale.short;
                localeMap[locale.short] = locale.short;
            }
        });

        // const momentLocale = localeMap[currentLanguageCode] || 'en';
        // console.log('Setting moment locale:', { currentLanguageCode, momentLocale, availableLocales: localeMap });
        // const result = moment.locale(momentLocale);
        // console.log('Moment locale result:', result);
    }, [currentLanguageCode, locales]);

    return currentLanguageCode;
};

export default useMomentLocale;
